import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import userReducer from './userReducer';
import errorReducer from './errorReducer';
import tagReducer from './tagReducer';
import subjectReducer  from './subjectReducer';
import inputReducer from './inputReducer';
import validityReducer from './validityReducer';

export default combineReducers({
    subjects: subjectReducer,
    errors: errorReducer,
    tags: tagReducer,
    users: userReducer,
    inputHistory: inputReducer,
    validity: validityReducer,
    router: routerReducer    
})



// WEBPACK FOOTER //
// ./src/reducers/index.js